var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import useMemo from 'rc-util/lib/hooks/useMemo';
import shallowEqual from 'shallowequal';
export const MenuContext = React.createContext(null);
function mergeProps(origin, target) {
    const clone = Object.assign({}, origin);
    Object.keys(target).forEach(key => {
        const value = target[key];
        if (value !== undefined) {
            clone[key] = value;
        }
    });
    return clone;
}
export default function InheritableContextProvider(_a) {
    var { children, locked } = _a, restProps = __rest(_a, ["children", "locked"]);
    const context = React.useContext(MenuContext);
    const inheritableContext = useMemo(() => mergeProps(context, restProps), [context, restProps], (prev, next) => !locked && (prev[0] !== next[0] || !shallowEqual(prev[1], next[1])));
    return (<MenuContext.Provider value={inheritableContext}>
            {children}
        </MenuContext.Provider>);
}
